import axios from 'axios';
import { Guid } from 'guid-typescript';

export default class CashTamerHttpClient {
    public constructor() {
        axios.defaults.baseURL = process.env.VUE_APP_CASHTAMER_API_BASE_URL;
        axios.defaults.headers.common['Content-Type'] = 'application/json; charset=UTF-8';
        axios.defaults.headers.common['CashTamer-CorrelationId'] = 'CTWEB-' + Guid.create();
    }

    public async getAsync(url: string): Promise<any> {
        return await axios.get(url);
    }

    public async postAsync(url: string, data: any): Promise<any> {
        return await axios.post(url, data);
    }

    public async secureGetAsync(url: string, jwt: string): Promise<any> {
        return await axios.get(url, {headers: {Authorization: 'Bearer ' + jwt}});
    }

    public async securePostAsync(url: string, data: any, jwt: string): Promise<any> {
        return await axios.post(url, data, {headers: {Authorization: 'Bearer ' + jwt}});
    }

    public async securePutAsync(url: string, data: any, jwt: string): Promise<any> {
        return await axios.put(url, data, {headers: {Authorization: 'Bearer ' + jwt}});
    }

    public async secureDeleteAsync(url: string, jwt: string): Promise<any> {
        return await axios.delete(url, {headers: {Authorization: 'Bearer ' + jwt}});
    }
}
